export function LearnIcon({ name, size = 20 }: { name: "arrow" | "book" | "play" | "check" | "bookmark" | "search" | "spark" | "reset"; size?: number }) {
  const paths = {
    arrow: <path d="M4 12h15m-6-6 6 6-6 6" />,
    book: <><path d="M12 5C8 2 4 3 3 4v15c3-2 6-1 9 1 3-2 6-3 9-1V4c-1-1-5-2-9 1Z" /><path d="M12 5v15" /></>,
    play: <path d="m9 5 11 7-11 7V5Z" />,
    check: <path d="m5 12 4 4L19 6" />,
    bookmark: <path d="M6 3h12v18l-6-4-6 4V3Z" />,
    search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 5 5" /></>,
    spark: <><path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5L12 3Z" /><path d="M20 2v4m-2-2h4" /></>,
    reset: <><path d="M4 10a8 8 0 1 1 1 8M4 4v6h6" /></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
